import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ViewChild,
} from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { I1FilenetServices } from 'src/app/acl-data/i1-filenet-services.service';

import { SearchResultDTO } from '../search-result.dto';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    templateUrl: './acl-search-main.component.html',
    styleUrls: ['./acl-search-main.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AclSearchMainComponent {
    documentIds: SearchResultDTO[] = [];
    objectStore$ = this.route.data.pipe(
        // map(routeValue => routeValue.parentMenu.data.parentMenu.data.id)
        map(routeValue => routeValue.parentMenu.data.id)
    );
    loading$ = new BehaviorSubject(false);
    resultsExceeded = false;
    errorSearching = false;

    @ViewChild('tabs') tabs: MatTabGroup;

    fullTextResults = false;

    lastSearch = null;

    constructor(
        private route: ActivatedRoute,
        private i1FilenetService: I1FilenetServices,
        private cdr: ChangeDetectorRef,
        public snakbar: MatSnackBar
    ) {}

    search = input => {
        console.log('Searching: ', input);
        this.lastSearch = input;
        this.loading$.next(true);
        this.objectStore$
            .pipe(
                switchMap(os =>
                    this.i1FilenetService.searchContract(os, input)
                ),
                take(1)
            )
            .subscribe(
                v => {
                    console.log('Updating');
                    this.resultsExceeded = v.status === 250;

                    this.fullTextResults =
                        input.textFilter && input.textFilter.length > 0;

                    this.documentIds = v.body;
                    this.cdr.detectChanges();
                    this.loading$.next(false);
                    this.tabs.selectedIndex = 1;
                },
                error => {
                    this.loading$.next(false);
                    this.errorSearching = true;
                    this.snakbar.open(
                        'The server was unable to process your search request, please try different filters or contact your system administrator',
                        'OK'
                    );
                }
            );
    };

    download = (noLimit: boolean) => {
        console.log('Downloading: ', this.lastSearch, noLimit);
        if (this.lastSearch === undefined || this.lastSearch === null) {
            return;
        }

        if (noLimit) {
            this.lastSearch.searchResultsLimit = environment.noLimitSearch;
            console.log('No Limit Download', this.lastSearch);
        } else {
            this.lastSearch.searchResultsLimit = environment.limitSearch;
        }
        this.loading$.next(true);
        this.objectStore$
            .pipe(
                switchMap(os =>
                    this.i1FilenetService.downloadSearchContract(
                        os,
                        this.lastSearch
                    )
                ),
                take(1)
            )
            .subscribe(response => {
                this.downLoadFile(
                    response,
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'SearchResults.xlsx'
                );
                this.loading$.next(false);
            });
    };

    /**
     * Method is use to download file.
     * @param data - Array Buffer data
     * @param type - type of the document.
     */
    downLoadFile(data: any, typeValue: string, filename: string) {
        console.log('Download Data');
        // const blob = new Blob([data], { type: typeValue });
        // const url = window.URL.createObjectURL(blob);
        // window.location.href = url;

        const a = document.createElement('a');
        document.body.appendChild(a);
        // a.style = 'display: none';

        const blob = new Blob([data], { type: typeValue });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        // const pwa = window.open(url);
        // if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
        //     alert('Please disable your Pop-up blocker and try again.');
        // }
    }
}
